import store from "../store/index.js";

export function nodeStyle(node){
  // console.log(node)
  node.label = node.data.name;
  node.relevance =0
  // node.labelStyle.padding = 20;
  // node.labelStyle.borderRadius=3
  node.fillColor = "#75cede";
  // node.lineColor = "#75cede";
  node.lineWidth = 1;
  // let min = 20;
  let max = 55;
  if (node.dataLinks.length > node.links.length){
      node.items = [{px: 0.4,py:-0.8, text:"",padding:0,scaleWithZoom:true,aspectRatio:1, backgroundStyle:{fillColor: "red"}}];
  }else{
      node.items = [];
  }
  initNode(node)
}

const initNode = function(node){
  // console.log(node)
  let type = node.data.type;
  node.radius =25;//节点圈的大小30
  // if(type == 3){ // 同一电话
  //   node.display = 'circle';
  //   node.image = "../../static/images/relation_shape_phone.png";
  //   node.imageSlicing = [0,0,60,60];
  // }else if(type == 4){ //同一公司地址
  //   node.display = 'circle';
  //   node.image = "../../static/images/relation_shape_company.png";
  //   node.imageSlicing = [0,0,60,60];
  // }else if(type == 5){ //同一住宅地址
  //   node.display = 'circle';
  //   node.image = "../../static/images/relation_shape_home.png";
  //   node.imageSlicing = [0,0,60,60];
  // }

  if(node.data.innode){
    node.radius =40
    if(node.data.type == 1){
      node.image = "../../static/images/innode_icon_company.png";
      store.state.innode_icon_company = true
      store.state.innode_icon_people = false
    }else if(node.data.type == 2){
      node.image = "../../static/images/innode_icon_people.png";
      store.state.innode_icon_company = false
      store.state.innode_icon_people = true
    }

    node.fillColor = "rgb(255,255,255)";
    // node.lineWidth = 10;
    // node.radius =40;
    // node.lineColor = "red";
    // node.display = 'droplet';
  }
  // 不是中间节点 不是关键管理人员
  if(node.data.innode == false &&node.data.properties.isSYR == 'false'){

    node.radius =15;//节点圈的大小30
    node.fillColor = "lightgray";
  }else{
    node.fillColor = "#f6bf5f";
  }

  if(parseInt(node.data.properties.cgzb) >=25&&node.data.properties.isSYR == 'true'){
    node.fillColor = "#b278e0";
  }

}

export function linkStyle(link){
  link.length = .5;
  link.radius = 1;
  // link.fromDecoration = "circle";
  link.toDecoration = "arrow";

  link.fillColor = '#bbb';//必须写在这 才能保证新增加的线条颜色保持一致

  // if(link.data.type == 3 || link.data.type == 4 || link.data.type == 5){
  //   link.fillColor = '#719cc7';
  // }
  // if(link.data.color==true){
  //   link.radius = 3;
  //
  //   link.fillColor = '#e66f5b';
  //
  //   // link.fillColor = "black"
  // }

  // 风险双击事件 由于返回的节点都是空的 所以需要做判断
  // if(link.data.properties == null||(!link.data.properties)){
  //   return
  // }
  // // 风险双击事件 由于返回的节点都是空的 所以需要做判断
  // if(link.data.properties == null||(!link.data.properties)){
  //   return
  // }
  if(link.data.properties.conprop && link.data.properties.conprop != "null"){
    let labelConprop = (link.data.properties.conprop*100).toFixed(2);
    // link.label = (link.data.properties.conprop * 100).toFixed(2) + "%";
    if(labelConprop < 0){
      link.label = "";
    }else if(labelConprop < 1&&labelConprop!=0){
      link.label = "<1%";
    }else{
      link.label = labelConprop + "%";
    }
    if((link.data.type.toString()).indexOf("6") != -1&&(link.data.type.toString()).indexOf("7") == -1){
      link.label +=",控股"
    }
    if((link.data.type.toString()).indexOf("6") == -1&&(link.data.type.toString()).indexOf("7") != -1){
      link.label +=",参股"
    }
    if((link.data.type.toString()).indexOf("6") != -1&&(link.data.type.toString()).indexOf("7") != -1){
      link.label +=",控股"
    }
    if(link.data.properties.position_desc && link.label){
        link.label += "，"+link.data.properties.position_desc
    }

    if(link.data.properties.legal){
      link.label += "，法人</br>";
    }
  } else if (link.data.properties.holderrto && link.data.properties.holderrto != "null") {
    link.label = link.data.properties.holderrto + "%";
    if (link.data.properties.position_desc) {
      link.label += "," + link.data.properties.position_desc
    }
    if (link.data.properties.legal) {
      link.label += ",法人";
    }
  } else if(link.data.properties.position_desc&&link.data.properties.legal){
    link.label = link.data.properties.position_desc
    if(link.data.properties.legal){
        link.label += "，法人</br>";
    }
  }else if(link.data.properties.position_desc&&!link.data.properties.legal){
    link.label = link.data.properties.position_desc
  }else if(!link.data.properties.position_desc&&link.data.properties.legal){
    link.label = "法人</br>";
  }else if(!link.data.properties.position_desc&&(link.data.type.toString()).indexOf("2") != -1){
     link.label ='任职'
  }
  // 个体负责人
  if(link.data.properties.fzr&&link.data.properties.fzr == "true"){
    link.label ='负责人'
  }
  // 十大股东显示
  // if(link.data.properties.holderrto){
  //   let holdeConprop = link.data.properties.holderrto
  //   link.label = link.data.properties.holderrto + "%";
  // }
  // 控制路径的关系路径
  // if(store.state.routeType == "contrlway"){
  //   if(link.data.properties.middlelink&& link.data.properties.middlelink== "middle"){
  //     link.fillColor = "#e66f5b"
  //     link.radius = 5;
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/common/chartOptions.js